export { LinktagService, linktag } from './linktag.service.js';
